import EzController from 'controllers/ez-base-controller';
import { sendTrackingEvent, trackCompleteEvent, findCategoryByElement } from 'components/analytics/conversions/tracking';

export default class EventTrackerController extends EzController {
  static values = {
    trackAction: String,
    completeAction: String,
    trackLabel: String,
    trackValue: String,
    includeData: String,
    sendFromElement: { type: Boolean, default: true },
  }

  track(event) {
    const payload = {
      action: this.trackActionValue,
    };

    if (this.hasTrackLabelValue) payload.label = this.trackLabelValue;
    if (this.hasTrackValueValue) payload.value = this.trackValueValue;

    Object.assign(payload, this.processIncludedData());

    /*
     * setting sendFromElement to false will force the event to
     * send from the body tag instead of the element.
     * This is good for things like modals that disappear
     * after events like ajax:success
    */
    const trackedEvent = { data: payload };
    if (this.sendFromElementValue) {
      trackedEvent.element = event.target;
    }

    sendTrackingEvent(trackedEvent);
  }

  trackComplete(event) {
    trackCompleteEvent({
      action: this.completeActionValue,
      category: findCategoryByElement(event.target),
    });
  }

  processIncludedData() {
    if (!this.hasIncludeDataValue) return {};

    const data = {};
    const values = this.includeDataValue.split(',').map((i) => i.trim());
    values.forEach((value) => {
      data[value] = this.element.dataset[value];
    });

    return data;
  }
}
